import React, {useCallback, useMemo} from 'react';
import {useIntl} from 'react-intl';

import {ESearchType} from 'coreClasses/search/ISearch';
import {useLocalesMgr} from 'coreHooks';

import PersonalizedContent from 'brand/app/contentful/components/Content/Subcomponents/PersonalizedContent';
import {useGeneralProvider} from 'brandComponents/_app-config/GeneralProvider';
import Typography from 'brandComponents/Typography';
import {QUICK_SEARCH_NO_RESULT_SLUG, QUICK_SEARCH_PAGE_INSTANCE_KEY} from 'brandConstants';
import {useSearchUtils} from 'brandHooks';

import messages from './messages';

import styles from './SearchPageNoResults.module.scss';

const SearchPageNoResults = () => {
	const intl = useIntl();
	const {managerRepository} = useGeneralProvider();
	const localesMgr = useLocalesMgr();

	const {query, noResults, hasSearchQuery} = useSearchUtils({
		searchInstanceKey: QUICK_SEARCH_PAGE_INSTANCE_KEY,
		searchType: ESearchType.QUICK_SEARCH
	});

	const backCTACallback = useCallback(() => {
		managerRepository.getFlyoutsMgr().closeAllFlyouts();
		localesMgr.updateUrl('/', false);
	}, []);

	const backCTAConfig = useMemo(() => ({
		variant: 'anything',
		onClick: backCTACallback,
		message: messages.backToShopButton
	}), []);

	if (!noResults) {
		return <></>;
	}

	return (
		<div className={styles['search-page-no-result__container']}>
			{hasSearchQuery && (
				<Typography classNames={styles['search-page-no-result__search-query']} variant="h1">
					{`${intl.formatMessage(messages.results)} "${query}"`}
				</Typography>
			)}
			<div>
				{noResults && hasSearchQuery && (
					<PersonalizedContent
						slug={QUICK_SEARCH_NO_RESULT_SLUG}
						message={messages.noResults}
						cta={backCTAConfig}
					/>
				)}
			</div>
		</div>
	);
};

export default SearchPageNoResults;
